module.exports = __webpack_public_path__ + "assets/img/Logo-ITESM.762b4a68.png";